import { UserSelectDto } from '@@types/api.types';
import { Modal } from '@components/core/modal.component';
import { EmptyStateContainer } from '@components/shared/empty-state-container.component';
import { LoadingStateContainer } from '@components/shared/loading-state-container.component';
import { useExpertProfileForUser } from '@queries/expert-profile.query';
import React from 'react';
import { ExpertProfileDetails } from './expert-profile-details.component';

interface ExpertProfileViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: UserSelectDto;
}

export const ExpertProfileViewModal: React.FC<ExpertProfileViewModalProps> = (props) => {
  const { isOpen, onClose, user } = props;

  const { data: expertProfile, error, isLoading: isProfileLoading } = useExpertProfileForUser(user.id);

  return (
    <Modal
      centered
      header={{
        title: 'Expert Profile',
      }}
      isOpen={isOpen}
      onClose={onClose}
      width="800px"
    >
      {isProfileLoading && <LoadingStateContainer />}
      {error && (
        <EmptyStateContainer
          message="This user hasn't created an Expert Profile yet"
          title="No Expert Profile"
        />
      )}
      {!isProfileLoading && !error && (
        <ExpertProfileDetails
          expertProfile={expertProfile}
          user={user}
        />
      )}
    </Modal>
  );
};
